// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
* Extracted from: SweetAlert
* Modified by: Istiak Tridip
*/
.IW46bHflm11iUfhGhc50 {
    width: 80px;
    height: 115px;
    margin: 0 auto;
}

.AftFBOO7zQ_Djw6npEus {
    width: 80px;
    height: 80px;
    position: relative;
    border-radius: 50%;
    box-sizing: content-box;
    border: 4px solid #4CAF50;
}

.AftFBOO7zQ_Djw6npEus::before {
    top: 3px;
    left: -2px;
    width: 30px;
    transform-origin: 100% 50%;
    border-radius: 100px 0 0 100px;
}

.AftFBOO7zQ_Djw6npEus::after {
    top: 0;
    left: 30px;
    width: 60px;
    transform-origin: 0 50%;
    border-radius: 0 100px 100px 0;
    animation: ghRspEMGf5ga7H9ZOq_g 4.25s ease-in;
}

.AftFBOO7zQ_Djw6npEus::before, .AftFBOO7zQ_Djw6npEus::after {
    content: '';
    height: 100px;
    position: absolute;
    background: transparent;
    transform: rotate(-45deg);
}

.Y6NlTCR45BWSbLTQmetz {
    height: 5px;
    background-color: #4CAF50;
    display: block;
    border-radius: 2px;
    position: absolute;
    z-index: 10;
}

.Y6NlTCR45BWSbLTQmetz.yQSkpgJMtdReJQCPAxWG {
    top: 46px;
    left: 14px;
    width: 25px;
    transform: rotate(45deg);
    animation: BwgwyIFtUIMZs0GX8PLo 0.75s;
}

.Y6NlTCR45BWSbLTQmetz.URgyv2UD48o533YGC0I5 {
    top: 38px;
    right: 8px;
    width: 47px;
    transform: rotate(-45deg);
    animation: Wq33ONlmVSfSyHowAbPh 0.75s;
}

.TNSSKQIRiwiHjLR_XlSJ {
    top: -4px;
    left: -4px;
    z-index: 10;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    position: absolute;
    box-sizing: content-box;
    border: 4px solid rgba(76, 175, 80, .5);
}

.txdhHcQ0F5OgrTCsRB7N {
    top: 8px;
    width: 5px;
    left: 26px;
    z-index: 1;
    height: 85px;
    position: absolute;
    transform: rotate(-45deg);
    background-color: transparent;
}

@keyframes ghRspEMGf5ga7H9ZOq_g {
    0% {
        transform: rotate(-45deg);
    }
    5% {
        transform: rotate(-45deg);
    }
    12% {
        transform: rotate(-405deg);
    }
    100% {
        transform: rotate(-405deg);
    }
}

@keyframes BwgwyIFtUIMZs0GX8PLo {
    0% {
        width: 0;
        left: 1px;
        top: 19px;
    }
    54% {
        width: 0;
        left: 1px;
        top: 19px;
    }
    70% {
        width: 50px;
        left: -8px;
        top: 37px;
    }
    84% {
        width: 17px;
        left: 21px;
        top: 48px;
    }
    100% {
        width: 25px;
        left: 14px;
        top: 45px;
    }
}

@keyframes Wq33ONlmVSfSyHowAbPh {
    0% {
        width: 0;
        right: 46px;
        top: 54px;
    }
    65% {
        width: 0;
        right: 46px;
        top: 54px;
    }
    84% {
        width: 55px;
        right: 0;
        top: 35px;
    }
    100% {
        width: 47px;
        right: 8px;
        top: 38px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/library/SuccessAnimation/SuccessAnimation.module.css"],"names":[],"mappings":"AAAA;;;CAGC;AACD;IACI,WAAW;IACX,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,QAAQ;IACR,UAAU;IACV,WAAW;IACX,0BAA0B;IAC1B,8BAA8B;AAClC;;AAEA;IACI,MAAM;IACN,UAAU;IACV,WAAW;IACX,uBAAuB;IACvB,8BAA8B;IAC9B,6CAAsC;AAC1C;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,SAAS;IACT,UAAU;IACV,WAAW;IACX,wBAAwB;IACxB,qCAA8B;AAClC;;AAEA;IACI,SAAS;IACT,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,qCAA+B;AACnC;;AAEA;IACI,SAAS;IACT,UAAU;IACV,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,uCAAuC;AAC3C;;AAEA;IACI,QAAQ;IACR,UAAU;IACV,UAAU;IACV,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI;QACI,yBAAyB;IAC7B;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,QAAQ;QACR,SAAS;QACT,SAAS;IACb;IACA;QACI,QAAQ;QACR,SAAS;QACT,SAAS;IACb;IACA;QACI,WAAW;QACX,UAAU;QACV,SAAS;IACb;IACA;QACI,WAAW;QACX,UAAU;QACV,SAAS;IACb;IACA;QACI,WAAW;QACX,UAAU;QACV,SAAS;IACb;AACJ;;AAEA;IACI;QACI,QAAQ;QACR,WAAW;QACX,SAAS;IACb;IACA;QACI,QAAQ;QACR,WAAW;QACX,SAAS;IACb;IACA;QACI,WAAW;QACX,QAAQ;QACR,SAAS;IACb;IACA;QACI,WAAW;QACX,UAAU;QACV,SAAS;IACb;AACJ","sourcesContent":["/**\n* Extracted from: SweetAlert\n* Modified by: Istiak Tridip\n*/\n.successCheckmark {\n    width: 80px;\n    height: 115px;\n    margin: 0 auto;\n}\n\n.checkIcon {\n    width: 80px;\n    height: 80px;\n    position: relative;\n    border-radius: 50%;\n    box-sizing: content-box;\n    border: 4px solid #4CAF50;\n}\n\n.checkIcon::before {\n    top: 3px;\n    left: -2px;\n    width: 30px;\n    transform-origin: 100% 50%;\n    border-radius: 100px 0 0 100px;\n}\n\n.checkIcon::after {\n    top: 0;\n    left: 30px;\n    width: 60px;\n    transform-origin: 0 50%;\n    border-radius: 0 100px 100px 0;\n    animation: rotate-circle 4.25s ease-in;\n}\n\n.checkIcon::before, .checkIcon::after {\n    content: '';\n    height: 100px;\n    position: absolute;\n    background: transparent;\n    transform: rotate(-45deg);\n}\n\n.iconLine {\n    height: 5px;\n    background-color: #4CAF50;\n    display: block;\n    border-radius: 2px;\n    position: absolute;\n    z-index: 10;\n}\n\n.iconLine.lineTip {\n    top: 46px;\n    left: 14px;\n    width: 25px;\n    transform: rotate(45deg);\n    animation: icon-line-tip 0.75s;\n}\n\n.iconLine.lineLong {\n    top: 38px;\n    right: 8px;\n    width: 47px;\n    transform: rotate(-45deg);\n    animation: icon-line-long 0.75s;\n}\n\n.iconCircle {\n    top: -4px;\n    left: -4px;\n    z-index: 10;\n    width: 80px;\n    height: 80px;\n    border-radius: 50%;\n    position: absolute;\n    box-sizing: content-box;\n    border: 4px solid rgba(76, 175, 80, .5);\n}\n\n.iconFix {\n    top: 8px;\n    width: 5px;\n    left: 26px;\n    z-index: 1;\n    height: 85px;\n    position: absolute;\n    transform: rotate(-45deg);\n    background-color: transparent;\n}\n\n@keyframes rotate-circle {\n    0% {\n        transform: rotate(-45deg);\n    }\n    5% {\n        transform: rotate(-45deg);\n    }\n    12% {\n        transform: rotate(-405deg);\n    }\n    100% {\n        transform: rotate(-405deg);\n    }\n}\n\n@keyframes icon-line-tip {\n    0% {\n        width: 0;\n        left: 1px;\n        top: 19px;\n    }\n    54% {\n        width: 0;\n        left: 1px;\n        top: 19px;\n    }\n    70% {\n        width: 50px;\n        left: -8px;\n        top: 37px;\n    }\n    84% {\n        width: 17px;\n        left: 21px;\n        top: 48px;\n    }\n    100% {\n        width: 25px;\n        left: 14px;\n        top: 45px;\n    }\n}\n\n@keyframes icon-line-long {\n    0% {\n        width: 0;\n        right: 46px;\n        top: 54px;\n    }\n    65% {\n        width: 0;\n        right: 46px;\n        top: 54px;\n    }\n    84% {\n        width: 55px;\n        right: 0;\n        top: 35px;\n    }\n    100% {\n        width: 47px;\n        right: 8px;\n        top: 38px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"successCheckmark": `IW46bHflm11iUfhGhc50`,
	"checkIcon": `AftFBOO7zQ_Djw6npEus`,
	"rotate-circle": `ghRspEMGf5ga7H9ZOq_g`,
	"iconLine": `Y6NlTCR45BWSbLTQmetz`,
	"lineTip": `yQSkpgJMtdReJQCPAxWG`,
	"icon-line-tip": `BwgwyIFtUIMZs0GX8PLo`,
	"lineLong": `URgyv2UD48o533YGC0I5`,
	"icon-line-long": `Wq33ONlmVSfSyHowAbPh`,
	"iconCircle": `TNSSKQIRiwiHjLR_XlSJ`,
	"iconFix": `txdhHcQ0F5OgrTCsRB7N`
};
export default ___CSS_LOADER_EXPORT___;
